/// <amd-module name="Build/Admin/Common/Stores/ProjectStore" />
import { Store } from "VSS/Reflux/Store";

import { ITeamProject } from "TFS/Services/TfsProjectService";

export class ProjectStore extends Store {
    public state: ITeamProject[] = [];

    constructor() {
        super("ProjectStoreChanged");
    }

    public updateProjects = (projects: ITeamProject[]): void => {
        this.state =  projects.splice(0);
        this.emitChanged();
    }
}
